const contactStatus = {
    1: '待處理',
    2: '處理中',
    3: '已完成'
}

export default contactStatus
